import { formatDate } from "@/lib/utils";

/**
 * Kratko relativno vrijeme za liste notifikacija i poruka („prije 5 min“).
 * Stariji od sedmice prikazuju datum — „prije 40 d“ niko ne preračunava napamet.
 */
export function relativeTime(unixSeconds: number, now: Date = new Date()): string {
  const sec = Math.floor(now.getTime() / 1000) - unixSeconds;
  if (sec < 60) return "upravo";
  const min = Math.floor(sec / 60);
  if (min < 60) return `prije ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `prije ${h} h`;
  const d = Math.floor(h / 24);
  if (d === 1) return "jučer";
  if (d < 7) return `prije ${d} d`;
  return formatDate(new Date(unixSeconds * 1000));
}
